export default __webpack_public_path__ + "static/media/editData.e3830bfe.svg";